import _ from 'underscore';
import v5_Model from '@/models/v5/model';
import Api from '@/lib/api/api';

var CodeModel = v5_Model.extend({
    check_syntax: function(devicegroup) {
        var promises = [
            this.generate_syntax_check_promise(this.get('agent_code'), 'agent_code', devicegroup),
            this.generate_syntax_check_promise(this.get('device_code'), 'device_code', devicegroup)
        ];

        return Promise.all(promises);
    },
    generate_syntax_check_promise: function(code, type, devicegroup) {
        var default_options = {
            method: 'POST',
            url: Api.urls.syntax_check()
        };

        var jsonapi_body = {
            data: {
                type: type,
                attributes: { code: code },
                relationships: {
                    devicegroup: {
                        id: devicegroup.id,
                        type: devicegroup.type
                    }
                }
            }
        };

        var options = _.extend(default_options, {
            data: JSON.stringify(jsonapi_body)
        });

        // Turn the jQuery thing into a real Promise
        return new Promise(function(resolve) {
            Api.ajax_v5(options).always(function(response) {
                resolve(this.process_syntax_check(response));
            }.bind(this));
        }.bind(this));
    },
    process_syntax_check: function(response) {
        var messages;
        if (response && response.responseJSON && response.responseJSON.errors) {
            messages = response.responseJSON.errors;
            if (response.responseJSON.meta && response.responseJSON.meta.warnings) {
                messages = messages.concat(response.responseJSON.meta.warnings);
            }
        // check first if this is a warnings response from syntax endpoint
        } else if ( response && response.meta && response.meta.warnings ){
            messages = response.meta.warnings;
        } else if ( response && response.meta ) {
            messages = response.meta;
        }
        var results = [];
        // Process any errors or warnings returned
        if (messages) {
            messages.forEach(function(api_error) {
                // Ignore non-syntax-check errors for now
                if (api_error.code !== 'CX005' && api_error.code !== 'WA001' && api_error.type !== 'warning' && api_error.type !== 'error') { return; }
                // WEB-1398 API response doesn't include 'file' in the meta portion
                // so we include it here.
                // TODO: need to rethink code errors. Perhaps too much
                // API logic is up in the views.
                // It gets worse for syntax checks, in the case of warnings only, not meta is provided, the warning is the error (this is easy)
                // IF there are errors (ie, a 400 response) meta is provided with meta.file, but no pointer, soooooo....
                // knowing if there is a source object included with the error is very helpful
                var pointer = api_error.source && api_error.source.pointer;
                // simplest case, single warning returned by a 200 w/ a file attribute... we are good to go
                if ( api_error.file ) {
                    results = results.concat(api_error);
                // case of multiple warnings errors returned by a 400 from syntax check
                } else if ( !pointer && api_error.meta ) {
                    results = results.concat(api_error.meta);
                // classic errors & warnings returned by some flavor of build
                } else if (pointer) {
                    ['device_code', 'agent_code'].forEach(function(source) {
                        if (pointer.indexOf(source) > -1) {
                            api_error.meta.forEach(function(err) {
                                err.file = source;
                            });
                        }
                    });
                    results = results.concat(api_error.meta);
                }
            });
        }
        return results;
    }
});

export default CodeModel;

